import { Injectable } from '@angular/core';
import { GenericService } from '../../../../core/services/GenericService';
import { ApiService } from '../../../../core/services';
import { IEtikettOverview } from '../interfaces/IEtikettOverview';
import { Observable } from 'rxjs';
import { IEtikettenart } from '../etikettenarten.registry';

@Injectable({
  providedIn: 'root'
})
export class EtikettenOverviewService extends GenericService<IEtikettOverview> {
  protected baseUrl = '/labels/overview';

  constructor(public apiService: ApiService) {
    super(apiService);
  }

  public getEtikettenarten(): Observable<IEtikettenart[]> {
    return this.apiService.get('/labels/etikettenarten');
  }
}
